
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWarningRectifiedIec as ObiWarningRectifiedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-warning-rectified-iec.js';
 
 
 

 
 export const ObiWarningRectifiedIec = createComponent({
   react: React,
   tagName: 'obi-warning-rectified-iec',
   elementClass: ObiWarningRectifiedIecElement,
   events: {
     
   }
  });
 
 